<template>
  <!-- INFO SIDEBAR CARD -->
  <q-card
    v-if="csv_ai_analysis"
    class="full-width q-mt-md"
  >
    <q-card-section class="q-pa-none">
      <q-item class="text-left">
        <q-item-section avatar>
          <q-avatar size="72px">
            <q-icon
              name="auto_awesome"
              color="amber"
            />
          </q-avatar>
        </q-item-section>
        <q-item-section>
          <q-item-label class="text-bold">
            Conversion du fichier csv
          </q-item-label>
          <q-item-label caption>
            Transformez votre csv grâce à notre rapport d'aide personnalisé.
          </q-item-label>
        </q-item-section>

        <q-item-section side>
          <q-btn
            round
            color="primary"
            icon="chevron_right"
            flat
            @click="showReportHome"
          />
        </q-item-section>
      </q-item>
    </q-card-section>
  </q-card>

  <!-- AI CSV DIALOG -->
  <q-dialog
    v-model="showReportDialog"
    maximized
    full-width
  >
    <q-layout
      view="hHh Lpr lff"
      container
      class="bg-drawer"
    >
      <q-page-container class="">
        <q-page class=" full-height centered-container q-pa-xl">
          <!-- HEADER -->
          <q-header
            bordered
            class="bg-page"
          >
            <q-toolbar class="text-default">
              <q-avatar size="72px">
                <q-icon
                  name="auto_awesome"
                  color="amber"
                />
              </q-avatar>
              <q-toolbar-title class="text-bold">
                Importation d'un fichier CSV de données brutes
              </q-toolbar-title>
              <q-btn
                :label="$q.lang.label.close"
                color="primary"
                unelevated
                icon-right="close"
                @click="showReportDialog = false"
              />
            </q-toolbar>
          </q-header>



          <!-- HOME PAGE -->
          <template v-if="view === 'start'">
            <div class="q-mt-xl q-pt-xl  text-center">
              <q-chip
                icon="error"
                color="negative"
                text-color="white"
                label="Échec de l'importation automatique"
                class="q-mb-sm"
              />
              <h2 class="text-h4 q-mb-md">
                Assistance pour la conversion de votre fichier CSV
              </h2>
              <p class="text-muted">
                L'importation automatique de vos données n'a pas abouti. Cependant, nous avons deux solutions alternatives pour vous :
              </p>
            </div>

            <div class="row q-mt-xl q-col-gutter-md">
              <!-- Csv Report choice -->
              <div class="col-xs-12 col-sm-6 col-6">
                <q-card class="q-pa-md cursor-pointer q-hoverable border-radius-6  q-card-shadow">
                  <span class="q-focus-helper" />
                  <q-card-section class="text-center q-pb-none">
                    <q-chip
                      icon="auto_awesome"
                      color="pastel-yellow"
                      text-color="black"
                      style="position: absolute; top: 0px; right: 0px;"
                    >
                      <span class="text-weight-bold">IA</span>
                    </q-chip>
                    <q-avatar
                      color="pastel-yellow"
                      size="76px"
                    >
                      <q-icon
                        name="fact_check"
                        color="black"
                      />
                    </q-avatar>
                  </q-card-section>

                  <q-card-section class="text-center  q-pb-none">
                    <span class="text-body2 q-pt-md q-pb-md text-bold">Instructions personnalisées</span>
                    <p class="text-muted">
                      Transformez vos données brutes grâce à notre rapport d'aide
                    </p>
                  </q-card-section>

                  <q-card-section class="text-center">
                    <q-btn
                      label="Commencer"
                      color="primary"
                      unelevated
                      @click="showCsvAnalysis()"
                    />
                  </q-card-section>
                </q-card>
              </div>

              <!-- Csv Report choice -->
              <div class="col-xs-12 col-sm-6 col-6">
                <q-card class="q-pa-md cursor-pointer q-hoverable border-radius-6  q-card-shadow">
                  <span class="q-focus-helper" />
                  <q-card-section class="text-center  q-pb-none">
                    <q-avatar
                      color="pastel-blue"
                      size="76px"
                    >
                      <q-icon
                        name="headset"
                        color="black"
                      />
                    </q-avatar>
                  </q-card-section>

                  <q-card-section class="text-center  q-pb-none">
                    <span class="text-body2 q-pt-md q-pb-md text-bold">Aide d'un expert</span>
                    <p class="text-muted">
                      Un agent de comptacrypto s'occupera d'intégrer votre fichier CSV.
                    </p>
                  </q-card-section>

                  <q-card-section class="text-center">
                    <q-btn
                      label="Contacter le support et obtenir un devis"
                      color="primary"
                      unelevated
                    />
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </template>

          <!-- Csv Analysis view -->
          <template v-if="view === 'csv_analysis'">
            <q-tab-panels
              v-model="csvAnalysisStep"
              animated
              vertical
            >
              <!-- Column name and order -->
              <q-tab-panel
                :name="1"
                class="q-pa-none"
              >
                <div class="text-center q-mt-xl q-pb-xl">
                  <q-chip
                    size="sm"
                    color="igor-yellow"
                    text-color="black"
                  >
                    ETAPE 1
                  </q-chip>
                  <h6 class="text-h5 text-bold q-mb-md q-mt-md">
                    Vérification des colonnes
                  </h6>
                  <p>
                    La première étape consiste à vérifier la correspondance entre les colonnes de votre fichier CSV et le format requis par notre système.
                  </p>
                </div>

                <q-card class="q-mb-md">
                  <q-card-section class="flex justify-between items-center">
                    <span class="text-bold">Votre fichier CSV:</span>
                    <q-chip
                      size="small"
                      class="comformity-score-chip"
                    >
                      Score de comformité: {{ correctColumnScore }} / {{ csv_ai_analysis.header_analysis.target_columns.length }}
                    </q-chip>
                  </q-card-section>

                  <q-markup-table
                    flat
                    class="q-mb-md q-px-md"
                  >
                    <thead>
                      <tr>
                        <th
                          v-for="column in csv_ai_analysis.header_analysis.original_columns"
                          :key="column"
                          class="text-left"
                        >
                          {{ column }}
                        </th>
                      </tr>
                    </thead>
                  </q-markup-table>

                  <q-card-section class="q-pt-none">
                    <span class="text-bold">Colonnes attendues:</span>
                  </q-card-section>

                  <q-markup-table
                    flat
                    class="q-mb-md q-mx-md"
                  >
                    <thead>
                      <tr>
                        <th
                          v-for="column in csv_ai_analysis.header_analysis.target_columns"
                          :key="column"
                          class="text-left"
                        >
                          {{ column }}
                        </th>
                      </tr>
                    </thead>
                  </q-markup-table>
                </q-card>

                <q-card>
                  <q-card-section>
                    <span class="text-bold">Étapes à suivre:</span>
                  </q-card-section>
                  <q-separator />
                  <q-card-section v-if="csv_ai_analysis.header_analysis?.instructions.length > 0">
                    <q-list dense>
                      <q-item
                        v-for="(instruction, index) in csv_ai_analysis.header_analysis.instructions"
                        :key="'instruction-column-' + index"
                        clickable
                      >
                        <q-item-section avatar>
                          <q-avatar
                            size="sm"
                            :color="getInstructionIconColor(instruction.action)"
                          >
                            <q-icon
                              :name="getInstructionIcon(instruction.action)"
                              color="black"
                            />
                          </q-avatar>
                        </q-item-section>
                        <q-item-section>
                          <q-item-label>
                            {{ getInstructionText(instruction) }}
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-card-section>

                  <q-card-section v-else>
                    Aucune instruction personnalisé n'est disponible pour le moment.
                  </q-card-section>
                </q-card>

                <!-- Previous and next button -->
                <div class="row justify-end q-mt-md">
                  <q-btn
                    color="primary"
                    label="Suivant"
                    icon-right="chevron_right"
                    @click="csvAnalysisStep++"
                  />
                </div>
              </q-tab-panel>

              <!-- Data Analysis -->
              <q-tab-panel
                :name="2"
                class="q-pa-none"
              >
                <div class="text-center q-mt-xl q-pb-xl">
                  <q-chip
                    size="sm"
                    color="igor-yellow"
                    text-color="black"
                  >
                    ETAPE 2
                  </q-chip>
                  <h6 class="text-h5 text-bold q-mb-md q-mt-md">
                    Analyse des données
                  </h6>
                  <p>La deuxième étape de notre processus d'analyse implique une inspection approfondie des données contenues dans votre fichier CSV pour identifier les anomalies, les valeurs manquantes et autres problèmes potentiels.</p>
                </div>

                <q-card>
                  <q-card-section>
                    <span class="text-bold">Étapes à suivre:</span>
                  </q-card-section>
                  <q-separator />
                  <q-card-section v-if="csv_ai_analysis.data_analysis?.column_instructions.length > 0">
                    <q-list dense>
                      <q-item
                        v-for="(instruction, index) in csv_ai_analysis.data_analysis.column_instructions"
                        :key="'instruction-column-2-' + index"
                        clickable
                      >
                        <q-item-section avatar>
                          <q-avatar
                            size="md"
                            color="pastel-green"
                          >
                            <q-icon
                              name="headset"
                              color="black"
                            />
                          </q-avatar>
                        </q-item-section>
                        <q-item-section>
                          <q-item-label>
                            <span class="text-bold">{{ instruction.column_name }}</span>
                          </q-item-label>
                          <q-item-label class="text-muted">
                            {{ instruction.instruction_fr }}
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-card-section>

                  <q-card-section v-else>
                    Aucune instruction personnalisé n'est disponible pour le moment.
                  </q-card-section>
                </q-card>

                <!-- Previous and next button -->
                <div class="row justify-end q-mt-md">
                  <q-btn
                    color="primary"
                    label="Précédent"
                    icon="chevron_left"
                    class="q-mr-md"
                    @click="csvAnalysisStep--"
                  />

                  <q-btn
                    color="primary"
                    label="Suivant"
                    icon-right="chevron_right"
                    @click="csvAnalysisStep++"
                  />
                </div>
              </q-tab-panel>



              <!-- General Suggestions -->
              <q-tab-panel
                :name="3"
                class="q-pa-none"
              >
                <div class="text-center q-mt-xl q-pb-xl">
                  <q-chip
                    size="sm"
                    color="igor-yellow"
                    text-color="black"
                  >
                    ETAPE 3
                  </q-chip>
                  <h6 class="text-h5 text-bold q-mb-md q-mt-md">
                    Suggestions Générales
                  </h6>
                  <p>La troisième étape de notre processus d'analyse se concentre sur l'identification des suggestions générales pour améliorer la qualité et l'utilisation des données.</p>
                </div>

                <q-card>
                  <q-card-section>
                    <span class="text-bold">Conseils généraux:</span>
                  </q-card-section>
                  <q-separator />
                  <q-card-section v-if="csv_ai_analysis.data_analysis?.general_suggestions.length > 0">
                    <q-list dense>
                      <q-item
                        v-for="(suggestion, index) in csv_ai_analysis.data_analysis.general_suggestions"
                        :key="'suggestion-column-2-' + index"
                        clickable
                      >
                        <q-item-section avatar>
                          <q-avatar
                            size="sm"
                            color="pastel-green"
                          >
                            <q-icon
                              name="headset"
                              color="black"
                            />
                          </q-avatar>
                        </q-item-section>
                        <q-item-section>
                          <q-item-label>
                            {{ suggestion.suggestion_fr }}
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-card-section>

                  <q-card-section v-else>
                    Aucun conseil personnalisé n'est disponible pour le moment.
                  </q-card-section>
                </q-card>

                <!-- Previous and next button -->
                <div class="row justify-end q-mt-md">
                  <q-btn
                    color="primary"
                    label="Précédent"
                    icon="chevron_left"
                    class="q-mr-md"
                    @click="csvAnalysisStep--"
                  />

                  <q-btn
                    color="primary"
                    label="Suivant"
                    icon-right="chevron_right"
                    @click="csvAnalysisStep++"
                  />
                </div>
              </q-tab-panel>

              <!-- Exemples -->
              <q-tab-panel
                :name="4"
                class="q-pa-none"
              >
                <div class="text-center q-mt-xl q-pb-xl">
                  <q-chip
                    size="sm"
                    color="igor-yellow"
                    text-color="black"
                  >
                    EXAMPLE
                  </q-chip>
                  <h6 class="text-h5 text-bold q-mb-md q-mt-md">
                    Exemple de transformation
                  </h6>
                  <p>Voici un exemple de transformation de votre fichier CSV</p>
                </div>

                <q-card class="q-mb-md">
                  <q-card-section class="flex justify-between items-center">
                    <span class="text-bold">Votre fichier CSV:</span>
                  </q-card-section>

                  <q-markdown
                    :src="csv_ai_analysis.examples.original_data"
                    class="q-px-md md-table q-table q-markup-table q-table__container q-table__card q-table--horizontal-separator q-table--flat q-table--no-wrap "
                  />
                  <q-card-section class="q-pt-none">
                    <span class="text-bold">Colonnes attendues:</span>
                  </q-card-section>
                  <q-markdown
                    :src="csv_ai_analysis.examples.corrected_data"
                    class="q-px-md md-table q-table q-markup-table q-table__container q-table__card q-table--horizontal-separator q-table--flat q-table--no-wrap "
                  />
                </q-card>

                <!-- Previous and next button -->
                <div class="row justify-end q-mt-md">
                  <q-btn
                    color="primary"
                    label="Précédent"
                    icon="chevron_left"
                    class="q-mr-md"
                    @click="csvAnalysisStep--"
                  />
                </div>
              </q-tab-panel>
            </q-tab-panels>




            <q-drawer
              v-model="showDrawer"
              :width="360"
              persistent
              bordered
            >
              <q-scroll-area
                style="height: calc(100% - 220px); margin-top: 0px;"
                class="q-pa-md"
              >
                <q-stepper
                  v-model="csvAnalysisStep"
                  vertical
                  animated
                  header-nav
                  flat
                  class="stepper-no-content text-primary csv-report-stepper"
                >
                  <template
                    v-for="(item, index) in sidebarProgressItems"
                    :key="index"
                  >
                    <q-step
                      done-color="positive"
                      active-color="info"
                      :name="index + 1"
                      :title="item.label"
                      :caption="item.caption"
                      :icon="item.icon"
                      :active-icon="item.icon"
                      :done="csvAnalysisStep > (index + 1)"
                    />
                  </template>
                </q-stepper>
              </q-scroll-area>

              <!-- Support card -->
              <div class="q-pa-md">
                <q-icon
                  name="headset"
                  color="black"
                  class="q-mb-sm"
                />
                <p class="text-bold">
                  Besoin d'aide ?
                </p>
                <p class="q-mb-none">
                  Comptacrypto peut s'occuper de la transformation de vos fichiers CSV
                </p>
                <p class="text-caption text-muted">
                  *sur devis
                </p>
                <q-btn
                  outline
                  color="primary"
                  label="Contactez-nous"
                />
              </div>
            </q-drawer>
          </template>
          <!-- correctColumnScore {{ correctColumnScore }}

          <pre>{{ csv_ai_analysis.examples.corrected_data }}</pre> -->

          <div class="col-12 q-pt-xl">
            <p class="text-muted">
              Vous pouvez aussi:
            </p>
            <!-- Download original csv,  -->
            <q-btn
              clickable
              label="Télécharger le fichier CSV de données brutes"
              icon="download"
              unelevated
              outline
              class="q-mr-sm q-mt-sm text-caption"
              @click="downloadCsvFile"
            />
            <q-btn
              clickable
              label="Télécharger le fichier template CSV générique"
              icon="download"
              unelevated
              outline
              class="q-mr-sm q-mt-sm text-caption"
              @click="downloadCsvTemplate"
            />
          </div>
        </q-page>
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>

<script>
import '@quasar/quasar-ui-qmarkdown/dist/index.css';
import { QMarkdown } from '@quasar/quasar-ui-qmarkdown';

export default {
  name: 'CsvAiAnalysis',
  components: {
    QMarkdown
  },
  props: {
    csv_ai_analysis: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showReportDialog: false,
      view: "start",
      csvAnalysisStep: 1,
      showDrawer: true
    }
  },
  computed: {
    correctColumnScore() {
      let score = 0;
      const originalColumns = this.csv_ai_analysis.header_analysis.original_columns;
      const targetColumns = this.csv_ai_analysis.header_analysis.target_columns;

      for (let i = 0; i < Math.min(originalColumns.length, targetColumns.length); i++) {
        if (originalColumns[i] === targetColumns[i]) {
          score++;
        } else {
          break;
        }
      }

      return score;
    },
    sidebarProgressItems() {
      return [
        {
          label: 'Vérification des colonnes',
          icon: 'mdi-table-check',
          caption: `${this.correctColumnScore}/${this.csv_ai_analysis.header_analysis.target_columns.length} colonnes validées`
        },
        {
          label: 'Analyse des données',
          icon: 'mdi-chart-line',
          caption: `${this.csv_ai_analysis?.data_analysis?.column_instructions?.length || 0} recommandations de formatage`
        },
        {
          label: 'Notes additionnelles',
          icon: 'mdi-note-text',
          caption: `${this.csv_ai_analysis?.data_analysis?.general_suggestions?.length || 0} suggestions générales`
        },
        {
          label: 'Exemples',
          icon: 'mdi-lightbulb-on',
          caption: this.csv_ai_analysis?.examples ? 'Exemple de transformation fourni' : 'Aucun exemple disponible'
        }
      ]
    }
  },
  methods: {
    showReportHome() {
      this.showReportDialog = true;
      this.view = 'start';
      this.csvAnalysisStep = 1;
    },
    showCsvAnalysis() {
      this.view = 'csv_analysis';
      this.csvAnalysisStep = 1;
    },
    getInstructionIcon(action) {
      switch (action) {
      case "add":
        return "add";
      case "remove":
        return "remove";
      case "rename":
        return "las la-pen";
      default:
        return "";
      }
    },
    getInstructionIconColor(action) {
      switch (action) {
      case "add":
        return "pastel-green";
      case "remove":
        return "pastel-red";
      case "rename":
        return "pastel-orange";
      default:
        return "";
      }
    },
    getInstructionText(instruction) {
      switch (instruction.action) {
      case "add":
        return `Ajouter la colonne "${instruction.value}"`;
      case "remove":
        return `Supprimer la colonne "${instruction.value}"`;
      case "rename":
        return `Renommer "${instruction.old_value}" en "${instruction.new_value}"`;
      default:
        return `Action inconnue: ${instruction.action}`;
      }
    },
    downloadCsvFile() {
      console.log("Download CSV File");
    },
    downloadCsvTemplate() {
      console.log("Download CSV Template");
    }
  }
}
</script>
<style scoped>
.q-stepper__label {
  color: black;
}
</style>
